import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import * as Api from "../lib/api";
import { AuthShell, Field } from "./LoginPage";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function SignupPage() {
  const { loginAs } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    email: "", password: "", company_name: "", uses_calculator: true,
  });
  const [busy, setBusy] = useState(false);

  function s(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function submit(e) {
    e.preventDefault();
    if (form.password.length < 8) { toast.error("Password must be ≥ 8 characters"); return; }
    setBusy(true);
    try {
      const d = await Api.signupAdmin(form);
      loginAs(d.access_token, d.user, d.team);
      toast.success("Account created — next: activate billing");
      nav("/billing");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  }

  return (
    <AuthShell title="Start a Team" subtitle="Create your Poseidon dealer account">
      <form onSubmit={submit} className="space-y-5" data-testid="signup-form">
        <Field label="Company Name" value={form.company_name} onChange={v => s("company_name", v)} testId="signup-company" required />
        <Field label="Admin Email" type="email" value={form.email} onChange={v => s("email", v)} testId="signup-email" required autoComplete="email" />
        <Field label="Password (min 8 chars)" type="password" value={form.password} onChange={v => s("password", v)} testId="signup-password" required autoComplete="new-password" />

        <div className="bg-black border-2 border-white/15 p-4">
          <button
            type="button"
            data-testid="toggle-uses-calculator"
            onClick={() => s("uses_calculator", !form.uses_calculator)}
            className="w-full text-left flex items-center justify-between gap-3"
          >
            <div className="flex-1 min-w-0">
              <div className="font-heading font-bold text-base text-white uppercase">I will use the calculator</div>
              <div className="text-xs text-white/60 mt-1">If ON, you count as a billable seat ($50/mo). If OFF, you're admin-only and free until you toggle this on.</div>
            </div>
            <div className={`w-14 h-8 border-2 shrink-0 flex items-center px-1 transition-colors ${
              form.uses_calculator ? "bg-[#F26522] border-[#F26522] justify-end" : "bg-transparent border-white/30 justify-start"
            }`}>
              <div className={`w-5 h-5 ${form.uses_calculator ? "bg-black" : "bg-white/60"}`} />
            </div>
          </button>
        </div>

        <button type="submit" disabled={busy} data-testid="signup-submit"
          className="w-full h-16 bg-[#F26522] text-black font-heading font-black tracking-wider uppercase text-base flex items-center justify-center gap-2 hover:bg-[#FF7A2A] transition-colors disabled:opacity-60">
          {busy && <Loader2 className="w-5 h-5 animate-spin" />}
          Create Team
        </button>

        <div className="text-center pt-4 border-t border-white/10">
          <span className="text-white/60 text-sm">Already have an account?</span>{" "}
          <Link to="/login" data-testid="link-login" className="text-[#F26522] hover:underline font-bold">Log In</Link>
        </div>
      </form>
    </AuthShell>
  );
}
